import { DriverDto, ProductLine, TruckDetailsDto, UrlKeyDto } from '@trucktrax/trucktrax-ts-common';
import { constants, DateWrapper } from '@trucktrax/trucktrax-common';
import { PositionDetailsDto } from '../types';
import { getIdFromUrl } from './appUtil';
import { DriverDetail } from '../store/selectors/messageSelectors';
import { statusPermittedByAssociatedWorkflow, WorkFlowProductLines } from './statusesUtil';

interface DriverMap {
  [truckId: number]: DriverDto;
}

export interface DriverWithTruck extends DriverDetail {
  truckDto?: { id: number };
}

export function getTruckToDriverMap(listOfDrivers: DriverWithTruck[]) {
  const driverMap: DriverMap = {};
  listOfDrivers.forEach(driver => {
    const truck = driver.truckDto;
    if (truck && truck.id) {
      driverMap[truck.id] = driver;
    }
  });
  return driverMap;
}

// I patched this bug but they issue seems to comes from the arguments
// TODO fix the bug in the data instead of patching it here
export function getDriversInCurrentRegion(
  positions: PositionDetailsDto[],
  selectedRegionUrl: string,
  truckToDriverMap: DriverMap,
) {
  const driverSet: DriverDto[] = [];

  if (!positions) {
    return driverSet;
  }

  positions.forEach(position => {
    if (position.trackedObject != null) {
      const regionUrl = position.region.url;
      const id = Number.parseInt(getIdFromUrl(position.trackedObject.url!), 10);
      const driver = truckToDriverMap[id];
      if (regionUrl === selectedRegionUrl && driver) {
        driverSet.push(driver);
      }
    }
  });

  return driverSet;
}

export function formatTimeSince(timestamp: string) {
  const duration = DateWrapper.differenceBetween(DateWrapper.now, timestamp);
  return `${duration.hours}h ${duration.minutes}m`;
}

export function shouldIgnorePositionBasedOnWorkflow(position: PositionDetailsDto): boolean {
  const {
    status = constants.STATUS_NAMES.Unknown,
    driver,
    productLine = ProductLine.None,
  } = position;
  const workflowPermittedStatus = statusPermittedByAssociatedWorkflow(
    status,
    driver?.isExternal ?? false,
    productLine as WorkFlowProductLines,
  );
  return workflowPermittedStatus === false;
}

/**
 * Determines if a position should be used for the GeoTrax map.
 * This is determined by the workflow associated with the provided position.
 */
export function shouldDisplayPosition(position?: PositionDetailsDto | undefined): boolean {
  if (!position?.driver) {
    return false;
  }
  return !shouldIgnorePositionBasedOnWorkflow(position);
}

type TrackedObjectType = TruckDetailsDto | DriverDto | UrlKeyDto | undefined;

export function extractTrackedObjectFromPosition(position: PositionDetailsDto): TrackedObjectType {
  if (position.trackedObject) {
    return position.trackedObject;
  }

  if (position.driver) {
    return position.driver;
  }

  if (position.ticket) {
    return position.ticket?.driver;
  }

  return undefined;
}
